// Library Class
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ConfirmDialogComponent } from '../../../../common/components/confirm-dialog/confirm-dialog.component';
// Class
import { MasterConstants } from '../../../../common/constants/master-constants';
import { SeedReturnLandingFilterVM } from '../../../../models/SeedReturn/SeedReturnLandingFilterVM';
import { DashboardFilter } from '../../../../models/DashboardFilter';
import { BroadcastService } from '../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../../services/infrastructure/config.service';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { CommonService } from '../../../../services/common/common.service';
import { SeedReturnService } from './../../../../services/seed/seed-return.service';
// Service Class
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { ExcelService } from '../../../../services/infrastructure/excel.service';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { OTIOrderLandingFilterVM } from '../../../../models/OTI/OTIOrderLandingFilterVM';
import { OtiService } from '../../../../services/oti/oti.service';

@Component({
    selector: 'app-seed-returns-dashboard',
    templateUrl: './seed-returns-dashboard.component.html',
    styleUrls: ['./seed-returns-dashboard.component.scss']
})

export class SeedReturnsDashboardComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('returnRequestTable', { read: MatSort }) returnRequestSort: MatSort;
    @ViewChild('returnRequestPaginator', { read: MatPaginator }) returnRequestPaginator: MatPaginator;
    @ViewChild('returnRequestDraftTable', { read: MatSort }) returnRequestDraftSort: MatSort;
    @ViewChild('returnRequestDraftPaginator', { read: MatPaginator }) returnRequestDraftPaginator: MatPaginator;

    private subscription = new Subscription();
    private selectedTabIndex = 0;
    private storageKey = '';

    headerYear: any;
    draftRequestDataSource: MatTableDataSource<any>;
    returnRequestDataSource: MatTableDataSource<any>;
    filters: OTIOrderLandingFilterVM = new OTIOrderLandingFilterVM();
    resultant: any = [];
    returnRequestDraftList: any = [];
    returnRequestList: any = [];
    headerCompany = MasterConstants.US_COMPANYCODE;
    dashboardFilter: DashboardFilter;
    returnRequestDraftColumns: string[] = [];
    returnRequestColumns: string[] = [];
    accountList: any;
    selectedAccount: number;
    validateEvolveData: any;
    readOnlyAccess = false;
    tabNode = false;
    userMenuAccessList: any;
    isEvolveAccountRestriction = false;
    selectedValue: string;
    filterValueList = new Array();
    searchTypeList: string[] = [];
    fromOrderDateFilter: any;
    toOrderDateFilter: any;
    productFilters: any;
    itemList: any = [];
    filter: SeedReturnLandingFilterVM = new SeedReturnLandingFilterVM();
    deliverToAccountdetails: any = {};
    processingStatusList: any = ['ACCEPTED', 'APPROVED', 'ERROR', 'INVOICED', 'PENDING', 'PLANNED', 'REJECTED', 'SUBMITTED'];
    productLineList: any;
    ddlAccounts: any[] = [];
    isApprovalAccess = false;
    notificationList: any = [{ 'id': 'Comments', 'value': 'Comments' }, { 'id': 'ManualProducts', 'value': 'Manual Products' },];
    productLine: string;
    selectedProductLineId: string;
    imagePath: string;
    bannerMessage = '';
    isValidForReturn = false;
    isOTIAccess = false;
    isValidForExceptionPeriod = false;
    isValidForNoExceptionPeriod = true;
    isProcessAccessed = false;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private matDialog: MatDialog,
        private localStorageService: LocalStorageService,
        private loaderService: LoaderService,
        private toastrService: ToastrService,
        private datePipe: DatePipe,
        private broadcastService: BroadcastService,
        private configService: ConfigService,
        private seedReturnService: SeedReturnService,
        private commonService: CommonService,
        public excelService: ExcelService,
        private otiService: OtiService) {
        this.dashboardFilter = new DashboardFilter();
    }

    // page initilization code
    ngOnInit() {
        if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
            this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
        }
        if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
            this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
            const sessionData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
            this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;

            if (this.headerCompany != undefined && this.isEvolveAccountRestriction == true) {
                this.subscription.add(this.commonService.getFilterDDLData().subscribe(result => {
                    this.ddlAccounts = result.accounts;
                }, error => LolLoggerService.error(error)));
            }
            const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
            if (evolveAccessData) {
                this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
                this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.RETURN_REQUEST_IP_APPROVAL, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList) || this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.RETURN_REQUEST_INVENTORY_PROTECTION, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
                this.isOTIAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.ORDER_TO_INVOICE);
            }
        }
        if (this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST)) {
            this.itemList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST));
        } else {
            this.subscription.add(this.seedReturnService.getItemNumberList().subscribe((result: any[]) => {
                this.localStorageService.set(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST, JSON.stringify(result));
                this.itemList = result;
            }));
        }

        this.isApprovalAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.RETURN_REQUEST_IP_APPROVAL);

        if (this.isApprovalAccess) {
            this.returnRequestDraftColumns = ['accountName', 'purchaseOrderNumber', 'accountNumber', 'dsmName', 'orderCreateDate', 'totalProducts', 'totalUnits', 'emptyStockPalletCount', 'emptyCboxCount', 'contextMenu'];
            this.returnRequestColumns = ['accountName', 'purchaseOrderNumber', 'accountNumber', 'dsmName', 'orderCreateDate', 'totalProducts', 'totalUnits', 'emptyStockPalletCount', 'emptyCboxCount', 'status', 'contextMenu'];
        }
        else {
            this.returnRequestDraftColumns = ['accountName', 'purchaseOrderNumber', 'accountNumber', 'orderCreateDate', 'totalProducts', 'totalUnits', 'emptyStockPalletCount', 'emptyCboxCount', 'contextMenu'];
            this.returnRequestColumns = ['accountName', 'purchaseOrderNumber', 'accountNumber', 'orderCreateDate', 'totalProducts', 'totalUnits', 'emptyStockPalletCount', 'emptyCboxCount', 'status', 'contextMenu'];
        }

        this.subscription.add(this.activatedRoute.paramMap.subscribe(params => {
            const paramProductLine = params.get('productLine');
            this.seedReturnService.dashboardSelectedProductLine = paramProductLine;
            this.storageKey = `seedReturn_${paramProductLine}_Filter`;

            this.seedReturnService.setSelectedProductLine(paramProductLine);
            this.productLine = this.seedReturnService.getProductLineTextByValue(paramProductLine);
            this.subscription.add(this.seedReturnService.SelectedProductLineId.subscribe(s => {
                this.selectedProductLineId = s;
                this.getProcessAccess();
                this.imagePath = this.seedReturnService.getProductLineImageById(s);
                this.setSearchTypeList();
                this.getProductLine();
                this.resetPageFilter();
                this.clearAllFilter();
                // this.getReturnRequestList();
                if (this.productLine != 'All') {
                    this.getBannerMessage();
                }
            }));
        }));
    }

    @HostListener('window:resize', ['$event']) onresize(event) {
        this.setAccSummaryTableHeight();
    }

    ngAfterViewInit() {
        // Set Dynamic Height of Panels
        this.setAccSummaryTableHeight();
    }

    // Tab changed
    tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
        this.selectedTabIndex = tabChangeEvent.index;

        this.setAccSummaryTableHeight();
    };

    // set account table height
    setAccSummaryTableHeight() {
        setTimeout(function () {
            const templateHeight = window.innerHeight - $('.TopSec').outerHeight() - $('.form-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 200;
            $('.activeReturnRequest').css('max-height', templateHeight + 'px');
            $('.draftReturnRequest').css('max-height', templateHeight + 'px');
        }, 100);
    }

    // Get account list
    getAccountData() {
        this.loaderService.setLoaderStatus(true);
        this.subscription.add(this.seedReturnService.getAccountList().subscribe(result => {
            this.accountList = result;
            this.loaderService.setLoaderStatus(false);
        }, error => this.loaderService.setLoaderStatus(false)));
    }

    // Search the account details on shipto / Deliverto dropdown
    accountSearchFn(term: string, item: any) {
        term = term.toLocaleLowerCase();
        return item.accountName.toLocaleLowerCase().indexOf(term) > -1
            || item.accountNumber.toString().indexOf(term) > -1
            || item.address1.toLocaleLowerCase().indexOf(term) > -1
            || item.city.toLocaleLowerCase().indexOf(term) > -1
            || item.state.toLocaleLowerCase().indexOf(term) > -1
            || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
    }

    getReturnRequestList() {
        this.loaderService.setLoaderStatus(true);

        let accountNumber: number;
        if (this.selectedAccount === undefined || this.selectedAccount === null) {
            accountNumber = 0;
        } else {
            accountNumber = this.selectedAccount;
        }

        this.subscription.add(this.seedReturnService.getReturnRequestList(this.filter).subscribe((result: any[]) => {
            this.returnRequestDraftList = result.filter(x => x.status === 'DRAFT');
            this.draftRequestDataSource = new MatTableDataSource(this.returnRequestDraftList);
            this.draftRequestDataSource.paginator = this.returnRequestDraftPaginator;
            this.isProcessAccessed && this.draftRequestDataSource.paginator.firstPage();
            this.draftRequestDataSource.sort = this.returnRequestDraftSort;
            this.returnRequestList = result.filter(x => x.status != 'DRAFT');
            const resultant = [];
            this.returnRequestList.reduce(function (res, value) {
                if (!res[value.returnRequestNumber]) {
                    res[value.returnRequestNumber] = { ...value }; // TO CLONE
                    res[value.returnRequestNumber].total = 0;
                    res[value.returnRequestNumber].StatusList = [];
                    resultant.push(res[value.returnRequestNumber]);
                }
                res[value.returnRequestNumber].StatusList.push(value.requestStatus);
                return res;
            }, {});

            this.returnRequestDataSource = new MatTableDataSource(resultant);
            this.returnRequestDataSource.paginator = this.returnRequestPaginator;
            this.returnRequestDataSource.paginator.firstPage();
            this.returnRequestDataSource.sort = this.returnRequestSort;

            this.loaderService.setLoaderStatus(false);
        }, error => { this.loaderService.setLoaderStatus(false); }));
    }

    // Create a new Cpp order(navigate to new order screen)
    createNewOrder() {
        if (!this.isValidForExceptionPeriod && !this.isValidForNoExceptionPeriod) {
            this.toastrService.error('The expection period for submitting returns for ' + this.productLine + ' is closed.');
        }
        else if (!this.isProcessAccessed && !this.isValidForReturn && this.isValidForNoExceptionPeriod) {
            this.toastrService.error('The period for submitting returns for ' + this.productLine + ' is closed.');
        }
        else {
            this.seedReturnService.setReturnRequestStatus(null);
            this.seedReturnService.setReturnRequestId(+0);
            if (this.productLine == "Inoculant") {
                this.seedReturnService.setIsReturnTypeForInoculant(true);
            }
            else {
                this.seedReturnService.setIsReturnTypeForInoculant(false);
            }
            this.router.navigate(['/seed-returns/return-request/']);
        }
    }

    // account change
    accountChange($event) {
        if ($event) {
            this.getReturnRequestList();
            this.getProcessAccess();
        }
    }

    // Event fired on clearing selected account from dropdown
    clearAccount() {
        this.getReturnRequestList();
        this.getProcessAccess();
    }

    // return sum of amount for draft orders
    getTotalDraftOrdersBalance() {
        return this.returnRequestDraftList.map(t => t.total).reduce((acc, value) => acc + value, 0);
    }

    // return sum of amount for placed orders
    getTotalPlacedOrdersBalance() {
        return this.returnRequestList.map(t => t.total).reduce((acc, value) => acc + value, 0);
    }

    // set the search filter list based on evolveaccountrestriction
    setSearchTypeList() {
        if (this.isEvolveAccountRestriction) {
            this.searchTypeList = ['Account', 'Product Line', 'Item Number', 'Request Date', 'Request Number', 'Customer PO Number'];
        }
        else if (this.isApprovalAccess) {
            this.searchTypeList = ['Account Name', 'Account Number', 'Product Line', 'Item Number', 'Request Date', 'Request Number', 'Customer PO#', 'By Notification'];
        }
        else {
            this.searchTypeList = ['Account Name', 'Account Number', 'Account City', 'Account State', 'Product Line', 'Item Number', 'Request Date', 'Request Number', 'Customer PO#'];
        }

        this.selectedValue = this.searchTypeList[0];
    }

    getProductLine() {
        this.loaderService.setLoaderStatus(true);
        this.subscription.add(this.seedReturnService.getProductLineList().subscribe((result) => {
            if (this.selectedProductLineId && this.selectedProductLineId.toUpperCase() == 'ALL') {
                this.productLineList = result;
            }
            else {
                this.productLineList = result.filter(x => x.id == this.selectedProductLineId);
            }
            this.loaderService.setLoaderStatus(false);
        }, error => { this.loaderService.setLoaderStatus(false); }));
    }

    // Reset Page Filter
    resetPageFilter() {
        this.productFilters = {
            'ProductLineId': this.selectedProductLineId,
            'ItemNo': [],
            'productName': null,
            'AccountName': null,
            'TxtAccountNo': null,
            'AccountNo': [],
            'FromOrderDate': null,
            'ToOrderDate': null,
            'ReturnRequestNumber': null,
            'Notification': null,
            'ProductLineFilter': null,
            'CustomerPO': null,
            'BranchPlant': null,
        };

        this.filter = {
            'productLineId': this.selectedProductLineId,
            'itemNo': null,
            'productName': null,
            'accountName': null,
            'accountCity': null,
            'accountState': null,
            'account': null,
            'fromOrderDate': null,
            'toOrderDate': null,
            'returnRequestNumber': null,
            'processingStatus': null,
            'notification': null,
            'productLineFilter': null,
            'customerPO': null,
            'branchPlant': null,
        };
    }

    // Clear selected filter
    clearFilter(filterValue) {
        const index = this.filterValueList.indexOf(filterValue);
        if (index > -1) {
            this.filterValueList.splice(index, 1);
            // remove product filter
            this.removeSelectedFilter(filterValue);

            if (this.filterValueList.length < 1) {
                this.getReturnRequestList();
            }
            this.setAccSummaryTableHeight();
        }
    }

    validateNumText(numInput) {
        const accountRegx = RegExp('^[0-9, ]+$');
        const isValidNumInput = accountRegx.test(numInput);
        if (!isValidNumInput) {
            this.toastrService.error('Invalid Input.');
            numInput = null;
        }
        return numInput;
    }
    // Validate the search input text
    validateInputText() {
        if (this.productFilters.TxtAccountNo) {
            this.productFilters.TxtAccountNo = this.validateNumText(this.productFilters.TxtAccountNo);
        }
        if (this.productFilters.ReturnRequestNumber) {
            this.productFilters.ReturnRequestNumber = this.validateNumText(this.productFilters.ReturnRequestNumber);
        }
        if (this.productFilters.CustomerPONumber) {
            this.productFilters.CustomerPONumber = this.validateNumText(this.productFilters.CustomerPONumber);
        }
    }

    // Retain Filter Value
    retainFilter(selectedObj: any, type: string) {
        const persistedFilter = this.localStorageService.get(this.storageKey);

        if (persistedFilter && persistedFilter !== 'null') {
            this.productFilters = JSON.parse(persistedFilter);
            this.localStorageService.set(this.storageKey, null);
        }

        this.validateInputText();
        if (this.filterValueList) {
            this.setAccSummaryTableHeight();
            let selectedIds = '';
            if (selectedObj && selectedObj.selectedValues) {
                const selectedValues = selectedObj.selectedValues as any[];
                if (type == 'ItemNo') {
                    selectedValues.forEach(x => { selectedIds = selectedIds + x.value + ','; });
                } else if (type == 'Notification') {
                    selectedValues.forEach(x => {
                        selectedIds = selectedIds + x.value + ',';
                    });
                } else if (type == 'ProductLineFilter') {
                    selectedValues.forEach(x => {
                        selectedIds = selectedIds + x.id + ',';
                    });
                }
                else {
                    selectedValues.forEach(x => { selectedIds = selectedIds + (type == 'AccountNo' ? x.accountNumber : x.id) + ','; });
                }
            }

            switch (type) {
                case 'ItemNo':
                    this.filter.itemNo = selectedIds;
                    break;
                case 'Notification':
                    this.filter.notification = selectedIds;
                    break;
                case 'ProductLineFilter':
                    this.filter.productLineFilter = selectedIds;
                    break;
            }

            // Create filterValueList from Product Filters
            this.filterValueList = [];
            if (this.productFilters) {
                if (this.productFilters.ProductName && this.productFilters.ProductName != '') {
                    this.filterValueList.push('Product Name : ' + this.productFilters.ProductName);
                    this.filter.productName = this.productFilters.ProductName.trim();
                }

                if (this.productFilters.CustomerPO && this.productFilters.CustomerPO != '') {
                    this.filterValueList.push('Customer PO Number : ' + this.productFilters.CustomerPO);
                    this.filter.customerPO = this.productFilters.CustomerPO.trim();
                }
                if (this.productFilters.BranchPlant && this.productFilters.BranchPlant != '') {
                    this.filterValueList.push('Branch Plant : ' + this.productFilters.BranchPlant);
                    this.filter.branchPlant = this.productFilters.BranchPlant.trim();
                }

                // Set product line
                if (this.productFilters.ProductLineFilter && this.productFilters.ProductLineFilter.length > 0) {
                    var strIno = '';
                    this.productFilters.ProductLineFilter.forEach(x => {
                        strIno = strIno + this.productLineList.filter(s => s.id == x)[0].value + ', ';
                    });
                    this.filterValueList.push('Product Line : ' + strIno.substr(0, strIno.length - 2));
                }

                // Set Item No
                if (this.productFilters.ItemNo && this.productFilters.ItemNo.length > 0) {
                    var strIno = '';
                    this.productFilters.ItemNo.forEach(x => {
                        strIno = strIno + x + ', ';
                    });
                    this.filterValueList.push('Item No : ' + strIno.substr(0, strIno.length - 2));
                }
                // Set Notification
                if (this.productFilters.Notification && this.productFilters.Notification.length > 0) {
                    var strIno = '';
                    this.productFilters.Notification.forEach(x => {
                        strIno = strIno + x + ', ';
                    });
                    this.filterValueList.push('By Notification : ' + strIno.substr(0, strIno.length - 2));
                }
                // text Account No
                if (this.productFilters.TxtAccountNo && this.productFilters.TxtAccountNo != '') {
                    this.filterValueList.push('Account No : ' + this.productFilters.TxtAccountNo);
                    this.filter.account = this.productFilters.TxtAccountNo.trim();
                }
                else if (this.productFilters.AccountNo && this.productFilters.AccountNo.length > 0) {
                    let strAct = '';
                    this.productFilters.AccountNo.forEach(x => {
                        strAct = strAct + x + ', ';
                    });

                    if (this.isEvolveAccountRestriction) {
                        this.filterValueList.push('Account : ' + strAct.substr(0, strAct.length - 2));
                    }
                    else {
                        this.filterValueList.push('Account No : ' + strAct.substr(0, strAct.length - 2));
                    }

                    if (this.productFilters.AccountNo == -1) {
                        this.filter.account = '-1';
                    }
                    else {
                        this.filter.account = strAct;
                    }
                }
                else {
                    this.filter.account = null;
                }
                // Account Name
                if (this.productFilters.AccountName && this.productFilters.AccountName != '') {
                    this.filterValueList.push('Account Name : ' + this.productFilters.AccountName);
                    this.filter.accountName = this.productFilters.AccountName.trim();
                }
                else {
                    this.filter.accountName = null;
                }

                // Account City
                if (this.productFilters.AccountCity && this.productFilters.AccountCity != '') {
                    this.filterValueList.push('Account City : ' + this.productFilters.AccountCity);
                    this.filter.accountCity = this.productFilters.AccountCity.trim();
                }
                else {
                    this.filter.accountCity = null;
                }

                // Account State
                if (this.productFilters.AccountState && this.productFilters.AccountState != '') {
                    this.filterValueList.push('Account State : ' + this.productFilters.AccountState);
                    this.filter.accountState = this.productFilters.AccountState.trim();
                }
                else {
                    this.filter.accountState = null;
                }

                // Web Order Number
                if (this.productFilters.ReturnRequestNumber && this.productFilters.ReturnRequestNumber != '') {
                    this.filterValueList.push('Request Number : ' + this.productFilters.ReturnRequestNumber);
                    this.filter.returnRequestNumber = this.productFilters.ReturnRequestNumber.trim();
                } else {
                    this.filter.returnRequestNumber = null;
                }

                if (this.productFilters.FromOrderDate
                    && this.productFilters.FromOrderDate != null
                    && this.productFilters.ToOrderDate
                    && this.productFilters.ToOrderDate != null) {
                    this.filterValueList.push('Request Date : (' + this.datePipe.transform(this.productFilters.FromOrderDate, 'MM/dd/yyyy') + ') - (' + this.datePipe.transform(this.productFilters.ToOrderDate, 'MM/dd/yyyy') + ')');
                    this.filter.fromOrderDate = new Date(this.productFilters.FromOrderDate).toDateString();
                    this.filter.toOrderDate = new Date(this.productFilters.ToOrderDate).toDateString();
                }
            }
            this.setAccSummaryTableHeight();
        }
    }

    // To remove/clear selected chip search filter
    removeSelectedFilter(filterValue) {
        const removeFilter = filterValue.split(' : ');
        const index = -1;
        switch (removeFilter[0].trim()) {
            case 'Item No':
                this.productFilters.ItemNo = null;
                this.filter.itemNo = null;
                break;
            case 'Product Line':
                this.productFilters.ProductLineFilter = null;
                this.filter.productLineFilter = null;
                break;
            case 'Customer PO Number':
                this.productFilters.CustomerPO = null;
                this.filter.customerPO = null;
                break;
            case 'Branch Plant':
                this.productFilters.BranchPlant = null;
                this.filter.branchPlant = null;
                break;
            case 'Product Name':
                this.productFilters.ProductName = null;
                this.filter.productName = null;
                break;
            case 'Account No':
                if (this.isEvolveAccountRestriction) {
                    this.productFilters.AccountNo = [];
                }
                else {
                    this.productFilters.TxtAccountNo = null;
                }
                this.productFilters.AccountNo = [];
                this.filter.account = null;
                break;
            case 'Account':
                if (this.isEvolveAccountRestriction) {
                    this.productFilters.AccountNo = [];
                }
                else {
                    this.productFilters.TxtAccountNo = null;
                }
                this.productFilters.AccountNo = [];
                this.filter.account = null;
                break;
            case 'Account Name':
                this.productFilters.AccountName = null;
                this.filter.accountName = null;
                break;
            case 'Account City':
                this.productFilters.AccountCity = null;
                this.filter.accountCity = null;
                break;
            case 'Account State':
                this.productFilters.AccountState = null;
                this.filter.accountState = null;
                break;
            case 'Request Number':
                this.productFilters.ReturnRequestNumber = null;
                this.filter.returnRequestNumber = null;
                break;

            case 'Request Date':
                this.productFilters.FromOrderDate = null;
                this.productFilters.ToOrderDate = null;
                this.filter.fromOrderDate = null;
                this.filter.toOrderDate = null;
                this.fromOrderDateFilter = '';
                this.toOrderDateFilter = '';
                break;

            case 'By Notification':
                this.productFilters.Notification = null;
                this.filter.notification = null;
                break;

            default:
                break;
        }
    }

    // Clear all filter
    clearAllFilter() {
        this.filterValueList = new Array();
        this.resetPageFilter();
        this.validateOrderDateFilter('clearAll', '');
        this.retainFilter(null, null);
        this.getReturnRequestList();
        this.setAccSummaryTableHeight();
    }

    // validate the order date filter on search filters
    validateOrderDateFilter(contextFrom, $event) {
        if (contextFrom == 'fromOrderDate') {
            fromDate = new Date($event.value);
            if (this.productFilters.ToOrderDate) {
                var toDate = new Date(this.productFilters.ToOrderDate);
                this.fromOrderDateFilter = (d: Date): boolean => {
                    const calendarDate = d;
                    return calendarDate <= toDate;
                };
            }
            this.toOrderDateFilter = (d: Date): boolean => {
                const calendarDate = d;
                return calendarDate >= fromDate;
            };
        }
        else if (contextFrom == 'toOrderDate') {
            toDate = new Date($event.value);
            this.fromOrderDateFilter = (d: Date): boolean => {
                const calendarDate = d;
                return calendarDate <= toDate;
            };
            if (this.productFilters.FromOrderDate) {
                var fromDate = new Date(this.productFilters.FromOrderDate);
                this.toOrderDateFilter = (d: Date): boolean => {
                    const calendarDate = d;
                    return calendarDate >= fromDate;
                };
            }
        }
        else if (contextFrom == 'clearAll') {
            this.fromOrderDateFilter = '';
            this.toOrderDateFilter = '';
        }
    }

    // Navigate to selected order detail
    navigateOrderDetail(obj: any, tabType: string) {
        let accountNumber = 0;
        if (obj) {
            if (this.selectedAccount === undefined || this.selectedAccount === null) {
                accountNumber = 0;
            } else {
                accountNumber = this.selectedAccount;
            }
            this.loaderService.setLoaderStatus(true);
            this.seedReturnService.setSelectedProductLine(this.seedReturnService.getProductLineValueById(obj.productLine));
            this.seedReturnService.setReturnRequestStatus(obj.status);

            this.localStorageService.set(this.storageKey, JSON.stringify(this.productFilters));

            this.seedReturnService.setReturnRequestId(+obj.returnRequestId);
            if (this.productLine == "Inoculant") {
                this.seedReturnService.setIsReturnTypeForInoculant(true);
            }
            else {
                this.seedReturnService.setIsReturnTypeForInoculant(false);
            }
            if (this.productLine != "Inoculant") {
                if (tabType == 'active') {
                    this.router.navigate(['/seed-returns/return-confirmation', obj.returnRequestNumber]);
                } else {
                    this.router.navigate(['/seed-returns/return-request', obj.returnRequestId]);
                }
            }
            else {
                if (tabType == 'active') {
                    if (obj.status == "PENDING" && this.isApprovalAccess) {
                        this.router.navigate(['/seed-returns/return-approve-reject', obj.returnRequestId]);
                    }
                    else {
                        this.router.navigate(['/seed-returns/return-confirmation', obj.returnRequestNumber]);
                    }
                } else {
                    this.router.navigate(['/seed-returns/return-request', obj.returnRequestId]);
                }
            }

            this.loaderService.setLoaderStatus(false);
        }
    }

    // Delete draft request
    deleteOrder(order: any) {
        if (order) {
            const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
                disableClose: true,
                width: '400px',
                data: { title: 'Delete Draft Request', message: 'Do you want to delete this saved request?', labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
            });
            this.subscription.add(dialogRef.afterClosed().subscribe(result => {
                // If user selected Yes
                if (result == true) {
                    this.loaderService.setLoaderStatus(true);
                    this.subscription.add(this.seedReturnService.deleteRequest(order.returnRequestId).subscribe(result => {
                        if (result) {
                            this.getReturnRequestList();
                        }
                        this.loaderService.setLoaderStatus(false);
                    }, error => this.loaderService.setLoaderStatus(false)));
                }
            }));
        }
    }

    // Get Banner Message
    getBannerMessage() {
        this.loaderService.setLoaderStatus(true);

        this.subscription.add(this.seedReturnService.getBannerMessage(this.selectedProductLineId).subscribe((result: any) => {
            this.bannerMessage = result.message;
            this.isValidForReturn = result.returnPeriodStatus;
            this.isValidForExceptionPeriod = result.exceptionPeriodStatus;
            this.isValidForNoExceptionPeriod = result.noExceptionPeriodStatus;
            this.seedReturnService.isExceptionPeriod = result.exceptionPeriodStatus;
            this.loaderService.setLoaderStatus(false);
        }, error => {
            this.loaderService.setLoaderStatus(false);
        }));
    }

    viewOrderToInvoice(element) {
        this.loaderService.setLoaderStatus(true);
        this.subscription.add(this.seedReturnService.checkOTIOrders(element.accountNumber, element.purchaseOrderNumber).subscribe(result => {
            if (result) {
                //this.localStorageService.set(MasterConstants.OTI_CUSTOMERPO, element.purchaseOrderNumber);
                //this.localStorageService.set(MasterConstants.OTI_ACCOUNTNUMBER, element.accountNumber);
              //this.router.navigate(['/cc/landing-data']);
              this.filters.account = element.accountNumber;
              this.filters.dateInDays = 0;
              this.filters.fromOrderDate = element.orderCreateDate !== null ? new Date(element.orderCreateDate) : null;
              this.filters.toOrderDate = new Date();
              this.filters.customerPO = element.purchaseOrderNumber;
              this.filters.orderStatus = null;
              this.filters.orderStatusText = "ALL";
              this.filters.productLineSegment = 'SEED';
              this.filters.dateRangeText = this.filters.fromOrderDate != null && this.filters.toOrderDate != null ? this.datePipe.transform(this.filters.fromOrderDate, 'MM/dd/yyyy')
                + ' - ' + this.datePipe.transform(this.filters.toOrderDate, 'MM/dd/yyyy') : "";
              this.otiService.setFilters(this.filters);
              this.router.navigate(['/order/dashboard']);
            } else {
                this.toastrService.error('Order not found. Please check back.');
            }
            this.loaderService.setLoaderStatus(false);
        }, error => this.loaderService.setLoaderStatus(false)));
    }

    public getStatusText(status: string): string {
        status = status.toUpperCase();
        let retVal = status;
        if (status === 'ACCEPTED') {
            retVal = 'SUBMITTED';
        } else if (status === 'PLANNING' || status === 'SHIPPED') {
            retVal = 'APPROVED';
        }
        return retVal;
    }

    public exportReturnRequest() {
        const exportData = [];
        this.loaderService.setLoaderStatus(true);

        this.seedReturnService.getReturnRequestExportList(this.filter).subscribe((result: any[]) => {
            const returnRequest = result.filter(x => x.status != 'DRAFT');
            const draftReturnRequest = result.filter(x => x.status === 'DRAFT');

            if (this.selectedTabIndex === 0 && returnRequest && returnRequest.length > 0) {
                returnRequest.forEach(x => {
                    exportData.push({
                        'RequestID': x.splitId ? `${x.returnRequestNumber}-${x.splitId}` : `${x.returnRequestNumber}`,
                        'Customer PO': x.purchaseOrderNumber,
                        'Account#': x.accountNumber,
                        'Account Name': x.accountName,
                        'Account Address': x.accountAddress1,
                        'Account City': x.accountCity,
                        'Account State': x.accountState,
                        'Account Zip': x.accountZipCode,
                        'Request Date': this.datePipe.transform(x.orderCreateDate, MasterConstants.DATE_MMDDYYYY),
                        'Item': x.productName,
                        'Product Line Description': this.seedReturnService.getProductLineTextById(x.productLine),
                        'Lot Number': x.lotNumber,
                        'Returned Units': x.returnUnits,
                        'Empty Pallets': x.emptyStockPalletCount,
                        'Empty CBOX': x.emptyCboxCount,
                        'Status': x.lineStatus,
                    });
                });
                this.excelService.exportAsExcelFile(exportData, `Active_${this.seedReturnService.dashboardSelectedProductLine}_Returns`);
            } else if (this.selectedTabIndex === 1 && draftReturnRequest && draftReturnRequest.length > 0) {
                draftReturnRequest.forEach(x => {
                    exportData.push({
                        'RequestID': x.splitId ? `${x.returnRequestNumber}-${x.splitId}` : `${x.returnRequestNumber}`,
                        'Customer PO': x.purchaseOrderNumber,
                        'Account#': x.accountNumber,
                        'Account Name': x.accountName,
                        'Account Address': x.accountAddress1,
                        'Account City': x.accountCity,
                        'Account State': x.accountState,
                        'Account Zip': x.accountZipCode,
                        'Request Date': this.datePipe.transform(x.orderCreateDate, MasterConstants.DATE_MMDDYYYY),
                        'Item': x.productName,
                        'Product Line Description': this.seedReturnService.getProductLineTextById(x.productLine),
                        'Lot Number': x.lotNumber,
                        'Returned Units': x.returnUnits,
                        'Empty Pallets': x.emptyStockPalletCount,
                        'Empty CBOX': x.emptyCboxCount,
                        'Status': x.lineStatus,
                    });
                });

                this.excelService.exportAsExcelFile(exportData, `Draft_${this.seedReturnService.dashboardSelectedProductLine}_Returns`);
            }
        });

        this.loaderService.setLoaderStatus(false);
    }
    getProcessAccess() {
        this.loaderService.setLoaderStatus(true);
        this.subscription.add(this.seedReturnService.getProcessAccessForNonSoybean(this.selectedProductLineId, this.selectedAccount).subscribe(result => {
            this.seedReturnService.isNewSeedReturnAllowed = result;
            this.isProcessAccessed = result;
            this.loaderService.setLoaderStatus(false);
        }, error => this.loaderService.setLoaderStatus(false)));
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
